<section class="hero inner-pages">
  <div class="base-fit">
    <img src="/assets/images/about/hero.png">
  </div>
  <div class="text-wrapper">
    <h2>{{'categories.Categories' | translate}}</h2>
  </div>
</section>
<div class="page-content">
  <section class="jobs-category">
    <div class="container">
      <div class="content">
        @if (dataLoading) {
        <div class="d-flex h-100 py-5">
          <div class="py-5 m-auto">
            <div class="spinner-border"></div>
          </div>
        </div>
        } @else {
        <div class="row g-4">
          <div class="col-xxl-3 col-md-4 col-6" *ngFor="let item of domains.data.list; index as i" data-aos="fade-up"
            [attr.data-aos-delay]="100*i">
            <a routerLink="/jobs" [queryParams]="{domain_id: item.id, domain_name: item.name}"
              (click)="trackSource('job_category_click', item)" class="item">
              <div class="img-container">
                <img [src]="item.icon" alt="">
              </div>
              <h3>{{ item.name }}</h3>
              <h5>{{ item.description }}</h5>
            </a>
          </div>
        </div>
        }
      </div>
    </div>
  </section>

</div>
